/**
 * @generated SignedSource<<6dd53400ec5d8989cffa99697b40068c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CustomFieldType = "FREE_TEXT" | "DROPDOWN" | "%future added value";
export type SettingsCustomFieldsTabQuery$variables = {};
export type SettingsCustomFieldsTabQuery$data = {
  readonly viewer: {
    readonly customFieldDefinitions: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string;
          readonly key: string;
          readonly fieldType: CustomFieldType;
          readonly options: ReadonlyArray<string> | null;
          readonly readOnly: boolean;
          readonly requiredOnResolution: boolean;
        } | null;
      } | null> | null;
    };
  } | null;
};
export type SettingsCustomFieldsTabQuery = {
  variables: SettingsCustomFieldsTabQuery$variables;
  response: SettingsCustomFieldsTabQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "TicketingCustomFieldDefinitionTypeConnection",
  "kind": "LinkedField",
  "name": "customFieldDefinitions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TicketingCustomFieldDefinitionTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TicketingCustomFieldDefinition",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fieldType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "options",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "readOnly",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "requiredOnResolution",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsCustomFieldsTabQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SettingsCustomFieldsTabQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e4fca2d7c43e60e371ed3ea42032847d",
    "id": null,
    "metadata": {},
    "name": "SettingsCustomFieldsTabQuery",
    "operationKind": "query",
    "text": "query SettingsCustomFieldsTabQuery {\n  viewer {\n    customFieldDefinitions {\n      edges {\n        node {\n          id\n          name\n          key\n          fieldType\n          options\n          readOnly\n          requiredOnResolution\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2cf3aaa09bcc873d25d3001910792b44";

export default node;
